// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2dDUV","empty":"ModalGraph_empty__2Q86n"};